import React, { Component } from 'react';
import { firestore } from '../../../firebase-config';
import Cabecalho from '../../../componentes/Cabecalho';
import CabecalhoPainel from '../../../componentes/CabecalhoPainel';
import { base_url, api_key } from '../../../config/config_api';
import { ValidatorForm, SelectValidator} from 'react-material-ui-form-validator';
import MenuItem from "@material-ui/core/MenuItem";
import { Redirect } from 'react-router-dom';

class VeiculosIntegracaoOfertaAutosIncluir extends Component {

    constructor (props){
        super(props);

        this.state = {
            estaGravando: false,
            carregandoDados: true,
            returnPagina: false,
            errosSubmit: null,
            errorLoading: false,
            errorsLoading: null,
            idRevenda: props.match.params.idRevenda,
            idVeiculo: props.match.params.idVeiculo,
            nome_revenda: "",
            imagens: [],
            veano_fabricacao: "",
            vefipe_ano_modelo: "",
            vequilometragem: "",
            vecambio: "",
            vefipe_combustivel: "",
            vefipe_marca: "",
            vefipe_name: "",
            opcionais: [],
            veportas: "",
            veiplaca: "",
            vecor: "",
            veobservacao: "",
            vevalor: "",
            vetipoveiculo: "",
            vecarroceria: "",

            exibir: 1,
            vedestaque: 0,
            veveiculonovo: 0,
            veblindado: false,
            vegarantia_fabrica: false,
            veipva_pago: true,

            usuarioLogado: JSON.parse(window.localStorage.getItem("usuarioLogado")),
        }
        this.mounted = false;
        this.goBack  = this.goBack.bind(this);
        this.handleChange  = this.handleChange.bind(this);
        this.handleSubmit  = this.handleSubmit.bind(this);

    }

    goBack(){
        this.props.history.goBack();
    }

    componentDidMount(){

        this.mounted = true;

        // firestore.settings({ timestampsInSnapshots: true });
        firestore.collection("revenda").doc(this.state.idRevenda)
        .get()
        .then(doc => {
            if (doc.exists) {
                this.setState({
                    nome_revenda: doc.data().penome_fantasia,
                });
            }
        }).catch(function(error) {
        });

        firestore.collection("revenda").doc(this.state.idRevenda).collection("veiculos").doc(this.state.idVeiculo)
        .get()
        .then(doc => {
            if (doc.exists) {

                this.setState({
                    opcionais: doc.data().opcionais.sort(compareMl),
                    imagens: doc.data().imagens,
                    veano_fabricacao: doc.data().veano_fabricacao,
                    vecambio: doc.data().vecambio,
                    vecor: doc.data().vecor,
                    veano_fabricacao: doc.data().veano_fabricacao,
                    vefipe_ano_modelo: doc.data().vefipe_ano_modelo,
                    vefipe_combustivel: doc.data().vefipe_combustivel,
                    vefipe_marca: doc.data().vefipe_marca,
                    vefipe_name: doc.data().vefipe_name,
                    veiplaca: doc.data().veiplaca,
                    veobservacao: doc.data().veobservacao,
                    veportas: doc.data().veportas,
                    vequilometragem: doc.data().vequilometragem,
                    vetipoveiculo: doc.data().vetipoveiculo,
                    vecarroceria: doc.data().vecarroceria,
                    vedestaque: doc.data().vedestaque,
                    veveiculonovo: doc.data().veveiculonovo,
                    veblindado: doc.data().veblindado,
                    vegarantia_fabrica: doc.data().vegarantia_fabrica,
                    veipva_pago: doc.data().veipva_pago,
                    vevalor: doc.data().vevalor,
                });

                this.setState({
                    carregandoDados: false,
                });
            }
        }).catch(function(error) {
            this.setState({
                carregandoDados: false,
            });
        });

    }

    componentWillUnmount(){
        this.mounted = false;
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(event) {

        this.setState({estaGravando: true, errosSubmit: null});

        var user = JSON.parse(window.localStorage.getItem("usuarioLogado"));

        var veiculo = {
            "api_key": api_key,
            "usuario": user.id,
            "id_revenda_firebase": this.state.idRevenda,
            "id_firebase": this.state.idVeiculo,
            "marca": this.state.vefipe_marca,
            "modelo": this.state.vefipe_name,
            "ano_fabricacao": this.state.veano_fabricacao,
            "ano_modelo": this.state.vefipe_ano_modelo,
            "cor": this.state.vecor,
            "cambio": this.state.vecambio,
            "combustivel": this.state.vefipe_combustivel,
            "placa": this.state.veiplaca,
            "observacao": this.state.veobservacao,
            "portas": this.state.veportas,
            "km": this.state.vequilometragem,
            "tipoveiculo": this.state.vetipoveiculo,
            "carroceria": this.state.vecarroceria,
            "exibir": (this.state.exibir === 1 ? true : false),
            "destaque": (this.state.vedestaque === 1 ? true : false),
            "ordenacao": 0, // TODO: Implementar ordenação
            "veiculonovo": (this.state.veveiculonovo === 1 ? true : false),
            "blindado": this.state.veblindado,
            "garantia_fabrica": this.state.vegarantia_fabrica,
            "ipva_pago": this.state.veipva_pago,
            "valor": parseFloat(this.state.vevalor),
            "opcionais": Object.keys(this.state.opcionais).map(key => {
                return this.state.opcionais[key].id;
            }),
            "imagens": this.state.imagens.map((imagem, index) => {
                return {
                    "url": imagem.fileUrl,
                    "url_thumb": imagem.fileThumb,
                    "ordenacao": index,
                    "nome": imagem.fileName
                };
            })
        };

        fetch(base_url+"/api/integracao/ofertaautos/enviar", { 
            method: "POST", 
            headers: { 
                'Content-Type': 'application/json',
            }, 
            body: JSON.stringify(veiculo)
        })
        .then(response => {

            response.json()
            .then(data => {
                if(data.status === 'success'){

                    console.log(data.data);
                    this.setState({estaGravando: false});  

                    var integracao = {
                        status: true,
                        id_anuncio: data.id,
                        url_anuncio: data.permalink,
                    };

                    firestore.collection('revenda').doc(this.state.idRevenda).collection('veiculos').doc(this.state.idVeiculo).collection('integracoes').doc("ofertaautos").set(integracao, { merge: true })
                    .then(res => { 
                        this.setState({returnPagina: true}); 
                    })
                    .catch(err => { 
                        this.setState({returnPagina: true});      
                    });
                   
                }else{
                    this.setState({errosSubmit: JSON.stringify(data.data)});
                }
            });
            this.setState({estaGravando: false});  

        })
        .catch(error => {
            console.log(error);
            this.setState({estaGravando: false});  
        });

    }

    render(){
        const { 
            errosSubmit,
            estaGravando,
            idRevenda,
            idVeiculo,
            vefipe_marca,
            vefipe_name,
            veano_fabricacao,
            vefipe_ano_modelo,
            vecor,
            vecambio,
            vefipe_combustivel,
            veiplaca,
            veportas,
            vequilometragem,
            vetipoveiculo,
            vecarroceria,
            veobservacao,
            exibir,
            vedestaque,
            veveiculonovo,
            veblindado,
            vegarantia_fabrica,
            veipva_pago,
            nome_revenda,
            opcionais,
            imagens,
            vevalor,
            carregandoDados,
            errorLoading,
            errorsLoading
        } = this.state;

        if(this.state.returnPagina){
            return <Redirect to={ "/revenda/"+idRevenda+"/veiculos/"+idVeiculo+"/visualizar" } />;
        }

        if(this.state.usuarioLogado !== null && this.state.usuarioLogado.role !== 'admin' && this.state.idRevenda !== this.state.usuarioLogado.revenda){
            return <Redirect to='/acesso-negado' />
        }

        return (
            <div>
                {
                    this.state.usuarioLogado !== null && this.state.usuarioLogado.role === 'admin' ? <Cabecalho /> :  <CabecalhoPainel />
                } 
                <div id="page-wrapper">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1 className="page-header">Incluir veículo Oferta Autos<br/><small>Revenda: { nome_revenda }</small></h1>
                        </div>
                    </div>
                    <div className="row formulario_integracao">
                        {
                                    
                            carregandoDados ? (<div className="col-lg-12"><img src="/img/aguarde.gif" alt="carregando"  style={{ height: '80px', marginBottom: '10px'}} /></div>) : (

                                errorLoading ? (<div style={{ display: errorsLoading !== null ? " block " : " none "  }} className="alert alert-danger" role="alert">{errorsLoading}</div>) : (
                        
                                    <div className="col-lg-12">
                                        <div className="panel panel-default">
                                            <div className="panel-heading">
                                                Integração Oferta Autos - Incluir veículo
                                            </div>
                                            <div className="panel-body">
      
                                                <ValidatorForm
                                                    ref="form"
                                                    onSubmit={this.handleSubmit}
                                                    onError={ errors => exibirErroSubmit(errors) }
                                                >
                                                <table className='table table-striped'>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ minWidth: '155px', width: '10%'}}></th>
                                                            <th style={{ width: '45%'}}>Dados Intermédio</th>
                                                            <th style={{ width: '45%'}}>Dados Oferta Autos</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        <tr>
                                                            <td>Marca <span className="alteracao-painel">*</span><span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ vefipe_marca.toUpperCase() }</td>
                                                            <td>{ vefipe_marca.toUpperCase() }</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Modelo <span className="alteracao-painel">*</span><span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ vefipe_name.toUpperCase() }</td>
                                                            <td>{ vefipe_name.toUpperCase() }</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Ano Fabricação <span className="alteracao-painel">*</span><span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ veano_fabricacao.toUpperCase() }</td>
                                                            <td>{ veano_fabricacao.toUpperCase() }</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Ano Modelo <span className="alteracao-painel">*</span><span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ vefipe_ano_modelo.toUpperCase() }</td>
                                                            <td>{ vefipe_ano_modelo.toUpperCase() }</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Cor <span className="alteracao-painel">*</span><span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ vecor.toUpperCase() }</td>
                                                            <td>{ vecor.toUpperCase() }</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Câmbio <span className="alteracao-painel">*</span><span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ formatCambio(vecambio) }</td>
                                                            <td>{ formatCambio(vecambio) }</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Combustível <span className="alteracao-painel">*</span><span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ vefipe_combustivel.toUpperCase() }</td>
                                                            <td>{ vefipe_combustivel.toUpperCase() }</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Placa <span className="alteracao-painel">*</span><span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ veiplaca.toUpperCase() }</td>
                                                            <td>{ veiplaca.toUpperCase() }</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Placa <span className="alteracao-painel">*</span><span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ veiplaca.toUpperCase() }</td>
                                                            <td>{ veiplaca.toUpperCase() }</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Portas <span className="alteracao-painel">*</span><span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ veportas }</td>
                                                            <td>{ veportas }</td>
                                                        </tr>
                                                        <tr>
                                                            <td>KM <span className="alteracao-painel">*</span><span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ vequilometragem }</td>
                                                            <td>{ vequilometragem }</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Tipo Veículo <span className="alteracao-painel">*</span><span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ vetipoveiculo.toUpperCase() }</td>
                                                            <td>{ vetipoveiculo.toUpperCase() }</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Carroceria <span className="alteracao-painel">*</span><span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ vecarroceria.toUpperCase() }</td>
                                                            <td>{ vecarroceria.toUpperCase() }</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Observação</td>
                                                            <td>{ veobservacao.toUpperCase() }</td>
                                                            <td>{ veobservacao.toUpperCase() }</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Preço anúncio</td>
                                                            <td>{ formatMoney(vevalor) }</td>
                                                            <td>{ formatMoney(vevalor) }</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Exibir <span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ exibir == 1 ? 'Sim' : "Não" }</td>
                                                            <td>
                                                                <SelectValidator
                                                                    value={ exibir }
                                                                    name="exibir"
                                                                    className="form-ui-bootstrap"
                                                                    onChange={this.handleChange}
                                                                    validators={["required"]}
                                                                    errorMessages={["Preenchimento obrigatório"]}
                                                                    >
                                                                        <MenuItem value="0">Não</MenuItem>
                                                                        <MenuItem value="1">Sim</MenuItem>
                                                                </SelectValidator>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Destaque <span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ vedestaque == 1 ? 'Sim' : "Não" }</td>
                                                            <td>
                                                                <SelectValidator
                                                                    value={ vedestaque }
                                                                    name="vedestaque"
                                                                    className="form-ui-bootstrap"
                                                                    onChange={this.handleChange}
                                                                    validators={["required"]}
                                                                    errorMessages={["Preenchimento obrigatório"]}
                                                                    >
                                                                        <MenuItem value="0">Não</MenuItem>
                                                                        <MenuItem value="1">Sim</MenuItem>
                                                                </SelectValidator>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Veículo Novo <span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ veveiculonovo == 1 ? 'Sim' : "Não" }</td>
                                                            <td>
                                                                <SelectValidator
                                                                    value={ veveiculonovo }
                                                                    name="veveiculonovo"
                                                                    className="form-ui-bootstrap"
                                                                    onChange={this.handleChange}
                                                                    validators={["required"]}
                                                                    errorMessages={["Preenchimento obrigatório"]}
                                                                    >
                                                                        <MenuItem value="0">Não</MenuItem>
                                                                        <MenuItem value="1">Sim</MenuItem>
                                                                </SelectValidator>
                                                            </td>
                                                        </tr> 
                                                        <tr>
                                                            <td>Blindado <span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ veblindado ? 'Sim' : "Não" }</td>
                                                            <td>
                                                                <SelectValidator
                                                                    value={ veblindado }
                                                                    name="veblindado"
                                                                    className="form-ui-bootstrap"
                                                                    onChange={this.handleChange}
                                                                    validators={["required"]}
                                                                    errorMessages={["Preenchimento obrigatório"]}
                                                                    >
                                                                        <MenuItem value="false">Não</MenuItem>
                                                                        <MenuItem value="true">Sim</MenuItem>
                                                                </SelectValidator>
                                                            </td>
                                                        </tr> 
                                                        <tr>
                                                            <td>Garantia de Fábrica <span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ vegarantia_fabrica ? 'Sim' : "Não" }</td>
                                                            <td>
                                                                <SelectValidator
                                                                    value={ vegarantia_fabrica }
                                                                    name="vegarantia_fabrica"
                                                                    className="form-ui-bootstrap"
                                                                    onChange={this.handleChange}
                                                                    validators={["required"]}
                                                                    errorMessages={["Preenchimento obrigatório"]}
                                                                    >
                                                                        <MenuItem value="false">Não</MenuItem>
                                                                        <MenuItem value="true">Sim</MenuItem>
                                                                </SelectValidator>
                                                            </td>
                                                        </tr> 
                                                        <tr>
                                                            <td>IPVA Pago <span className="preenchimento-obrigatorio">*</span></td>
                                                            <td>{ veipva_pago ? 'Sim' : "Não" }</td>
                                                            <td>
                                                                <SelectValidator
                                                                    value={ veipva_pago }
                                                                    name="veipva_pago"
                                                                    className="form-ui-bootstrap"
                                                                    onChange={this.handleChange}
                                                                    validators={["required"]}
                                                                    errorMessages={["Preenchimento obrigatório"]}
                                                                    >
                                                                        <MenuItem value="false">Não</MenuItem>
                                                                        <MenuItem value="true">Sim</MenuItem>
                                                                </SelectValidator>
                                                            </td>
                                                        </tr> 
                                                        <tr>
                                                            <td>Opcionais</td>
                                                            <td>
                                                                {
                                                                    Object.keys(opcionais)
                                                                    .map(key => {
                                                                        return (
                                                                            <span key={key}>{ opcionais[key].descricao.toUpperCase() }<br/></span>
                                                                        )
                                                                    })
                                                                }
                                                            </td>
                                                            <td>
                                                                {
                                                                    Object.keys(opcionais)
                                                                    .map(key => {
                                                                        return (
                                                                            <span key={key}>{ opcionais[key].descricao.toUpperCase() }<br/></span>
                                                                        )
                                                                    })
                                                                }
                                                            </td>
                                                        </tr>  
                                                        <tr>
                                                            <td>Imagens</td>
                                                            <td>
                                                                {      
                                                                    imagens !== undefined && imagens.length > 0 ? 
                                                                    ( 
                                                                        Object.keys(imagens)
                                                                        .map(key => {
                                                                            
                                                                            return (
                                                                                imagens[key].fileUrl !== null && imagens[key].fileThumb !== null ? 
                                                                                <div key={key}><img src={ imagens[key].fileThumb } alt={ imagens[key].fileName }  style={{ height: '80px', marginBottom: '10px'}} /><br/></div>
                                                                                : null
                                                                            )
                                                                            
                                                                        })
                                                                    )
                                                                    : null
                                                                }
                                                            </td>
                                                            <td>
                                                                {      
                                                                    imagens !== undefined && imagens.length > 0 ? 
                                                                    ( 
                                                                        Object.keys(imagens)
                                                                        .map(key => {
                                                                            
                                                                            return (
                                                                                imagens[key].fileUrl !== null && imagens[key].fileThumb !== null ? 
                                                                                <div key={key}><img src={ imagens[key].fileThumb } alt={ imagens[key].fileName }  style={{ height: '80px', marginBottom: '10px'}} /><br/></div>
                                                                                : null
                                                                            )
                                                                            
                                                                        })
                                                                    )
                                                                    : null
                                                                }
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table> 
                                                <p><span className="alteracao-painel">*</span> Dados da revenda devem ser alterados no painel <br/><span className="alteracao-app">*</span> Dados do veículo devem ser alterados no painel ou aplicativo <br/><span className="preenchimento-obrigatorio">*</span> Campo obrigatório</p>
                                                <div style={{ display: estaGravando ? " block " : " none "  }}><img src="/img/aguarde.gif" alt="carregando"  style={{ height: '80px', marginBottom: '10px'}} /></div>
                                                <div style={{ display: errosSubmit !== null ? " block " : " none "  }} className="alert alert-danger" role="alert">{errosSubmit}</div>
                                                <button onClick={this.goBack} disabled={estaGravando} className="btn btn-warning" >Voltar</button>&nbsp;&nbsp;<button type="submit" disabled={estaGravando} className="btn btn-primary" >Enviar</button>

                                                </ValidatorForm>
                                            </div>
                                        </div>
                                    </div>

                                )
                            )
                        }
                    </div>
                </div>
            </div>

        )
    }

}

function formatMoney(value) {

    var places = 2;
    var symbol = "R$ ";
    var thousand = ".";
    var decimal = ",";

	places = !isNaN(places = Math.abs(places)) ? places : 2;
	symbol = symbol !== undefined ? symbol : "$";
	thousand = thousand || ",";
	decimal = decimal || ".";
	var number = value, 
	    negative = number < 0 ? "-" : "",
	    i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
	    j = (j = i.length) > 3 ? j % 3 : 0;
	return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
};

function compareMl(a, b) {
    const genreA = a.descricao;
    const genreB = b.descricao;
    
    let comparison = 0;
    if (genreA > genreB) {
      comparison = 1;
    } else if (genreA < genreB) {
      comparison = -1;
    }
    return comparison;
}

function exibirErroSubmit(errors){
    window.scrollTo(0, 0);
    alert("Campos obrigatórios não preenchidos!");
}

function formatCambio(value){
    if(value === 'A'){
        return "AUTOMÁTICO";
    }else{
        return "MANUAL";
    }
}

export default VeiculosIntegracaoOfertaAutosIncluir